export default __webpack_public_path__ + "static/b02677fb82006f07b2977e914078e8d9.png";